// extracted by mini-css-extract-plugin
module.exports = {"customModalHeader":"TransactionAuditTrail_customModalHeader__1G41I","title":"TransactionAuditTrail_title__1K1tE"};